export default __webpack_public_path__ + "static/media/icono-empresas-gris.7a8dc6d0.svg";